module.exports = __webpack_public_path__ + "img/icon-6.d7dabf32.png";